import {
  SIMULADOR_FINANCIERO_GET_CREDITS_COMPARE_BEGIN,
  SIMULADOR_FINANCIERO_GET_CREDITS_COMPARE_SUCCESS,
  SIMULADOR_FINANCIERO_GET_CREDITS_COMPARE_FAILURE,
  SIMULADOR_FINANCIERO_GET_CREDITS_COMPARE_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_SF } from '../../../common/config';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getCreditsCompare({body = {}} = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SIMULADOR_FINANCIERO_GET_CREDITS_COMPARE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.post(REACT_APP_API_SF + "/creditsCompare", body);
      doRequest.then(
        (res) => {
          dispatch({
            type: SIMULADOR_FINANCIERO_GET_CREDITS_COMPARE_SUCCESS,
            data: res.data.data[0],
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SIMULADOR_FINANCIERO_GET_CREDITS_COMPARE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetCreditsCompareError() {
  return {
    type: SIMULADOR_FINANCIERO_GET_CREDITS_COMPARE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_GET_CREDITS_COMPARE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getCreditsComparePending: true,
        getCreditsCompareError: null,
      };

    case SIMULADOR_FINANCIERO_GET_CREDITS_COMPARE_SUCCESS:
      // The request is success
      let comparadorDeLineas = {...state.comparadorDeLineas};
      let aux = [];
      let lineasCreditoNombre = [];
      action.data.forEach((credito) => {
        aux.push(
          {
            id: credito.lc_id,
            name: credito.nombreLineaComercial,//'Santander Prendario Tradicional',
            title: credito.descBeneficio,//'Financiación especial día del padre',
            description: credito.requisitos,//`Promoción válida en toda la red de concesionarios oficiales Renault de Argentina. Exclusivo para las operaciones ingresadas y aprobadas a partir del 18/06/2019 inclusive. Modelo: Usados. Moneda: pesos. Tipo de Tasa: Fija. Plazo 12 meses. : Moneda: pesos. Tipo de Tasa: Fija. Tasa Nominal Anual (TNA): 24,90%. Tasa Efectiva Anual (TEA): 27,9%. Costo Financiero Total sin impuestos (CFT): 27,9%. Costo Financiero Total con impuestos (CFT): 33,82%. Monto máximo a financiar para todos los modelos hasta 8% el valor del auto. El valor de la primera cuota podrá variar en caso en que los días contados desde la fecha de liquidación del préstamo a la fecha de vencimiento de dicha cuota, superen los 30 días.`,
            entidadFinanciera: credito.entidadOtorgante, // 'Santander Río S.A.',
            cft: credito.CFT, //'5% - 30%',
            tna: credito.TNA, //'10% - 25%',
            valorMaximoPesos: credito.montoMaximo, //800000,
            valorMaximoPorc: credito.porcMontoMaxFinanciar, //100,
            plazos: credito.Plazos, //'12, 18, 24, 36, 48, 60'
            tipoTasaID: credito.tipoTasaID,
            tipoTasaDesc: credito.tipoTasaDesc,
            showBtnElegir: false
          }
        );
        lineasCreditoNombre.push(
          {
            label: credito.nombreLineaComercial,
            value: credito.lc_id,
            id: 'lineaCreditoNombre'
          }
        );
      });
      comparadorDeLineas.lineas = [...aux];
      comparadorDeLineas.lineasFiltradas = [...aux];
      comparadorDeLineas.lineasCreditoNombre = lineasCreditoNombre;
      return {
        ...state,
        comparadorDeLineas: comparadorDeLineas,
        getCreditsComparePending: false,
        getCreditsCompareError: null,
      };

    case SIMULADOR_FINANCIERO_GET_CREDITS_COMPARE_FAILURE:
      // The request is failed
      return {
        ...state,
        getCreditsComparePending: false,
        getCreditsCompareError: action.data.error,
      };

    case SIMULADOR_FINANCIERO_GET_CREDITS_COMPARE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getCreditsCompareError: null,
      };

    default:
      return state;
  }
}
